/**
 * Created by piotr.pozniak@thebeaverhead.com on 01/12/2021.
 */

import React from "react";
import classnames from "classnames";

/**
 * @param {Object} props
 * @param {String} [props.icon="autorenew"] - material icon name
 * @param {String} [props.label="Recurring"] - visible badge label
 * @param {String} props.badgeType - badge type, used as a styling hook
 */
const EventBadge = ({ icon = "autorenew", label = "Recurring", badgeType }) => {
  return (
    <div
      className={classnames(`dce--event-badge dce--event-badge-${badgeType}`)}
    >
      <i className={"material-icons"} aria-hidden="true">
        {icon}
      </i>
      <span>{label}</span>
    </div>
  );
};

export default EventBadge;
